import { IPrimaryKey } from "../interfaces/iprimary-key";
import { UnidadeMedicoEspecialidadeModel } from "./unidade-medico-especialidade.model";
import { ProcedimentoModel } from "./procedimento.model";
import { PacienteModel } from "./paciente.model";
import { PlanoModel } from "./plano.model";
import { AtendimentoModel } from "./atendimento.model";
import { Cid10Model } from "./cid10.model";

export class MarcacaoPrimaryKey implements IPrimaryKey<MarcacaoModel> {
  seq_Agenda: number = 0;

  get id(): string {
    return `${this.seq_Agenda}`;
  }
}
export class MarcacaoModel extends MarcacaoPrimaryKey {
  seq_Corpo_Clinico: number = 0;
  seq_Estab: number = 0;
  seq_Setor: number = 0;
  seq_Clinica: number = 0;
  seq_Grade?: number;
  numero_Guia?: number;
  seq_Beneficiario?: number;
  data_Agenda: Date = new Date();
  hora_Agenda: number = 0;
  observacao?: string;
  data_Comparecimento?: Date;
  hora_Comparecimento?: number;
  relatorio_Profissional?: string;
  PA?: string;
  FC?: string;
  peso?: string;
  altura?: string;
  prescricao?: string;
  prescricao_2?: string;
  prescricao_3?: string;
  ind_Cancelada?: boolean;
  data_Cancelamento?: Date;
  hora_Cancelamento?: number;
  usuario_Cancelamento?: string;
  seq_Motivo_Falta?: number;
  data_Justificativa_Falta?: Date;
  seq_Agenda_Falta_Justificada?: number;
  data_Marcacao?: Date;
  hora_Marcacao?: string;
  usuario_Marcacao?: string;
  seq_Agenda_Grade_Cancel?: number;
  data_Realizacao_Consulta?: Date;
  hora_Realizacao_Consulta?: number;
  anaminese_Laudo?: string;
  medicamentos_Laudo?: string;
  alergias_Laudo?: string;
  resultado_Laudo?: string;
  indices_Risco_Laudo?: string;
  conclusao_Laudo?: string;
  recomendacoes_Laudo?: string;
  usuario_Saude_Atd?: number;
  seq_Operadora?: number;
  seq_Plano_Operadora?: number;
  ind_Retorno?: boolean;
  ind_Encaixe_Consulta?: boolean;
  ind_Benef_Cancel?: boolean;
  ind_Prof_Cancel?: boolean;
  ind_Presenca_Confirmada?: boolean;
  data_Confirmacao?: Date;
  usuario_Confirmacao?: string;
  hora_Confirmacao?: string;
  evolucao?: string;
  queixa?: string;
  exame_Fisico?: string;
  solicitacoes?: string;
  pareceres?: string;
  cirurgia?: string;
  rel_Profis?: string;
  prescricao_Azul?: string;
  pedido_Exames?: string;
  //pedido_Exames?: string[];
  seq_Cid?: number;
  ind_Evolucao_Avulsa?: boolean;
  observacao_Marcacao?: string;
  ind_Agenda_Extra?: boolean;
  tipo_Faturamento?: string;
  ind_Consultorio?: boolean;
  ind_Prontuario_Avulso?: boolean;
  ind_SMS_Enviado?: boolean;
  data_SMS?: Date;
  usuario_SMS?: string;
  seq_Beneficio?: number;

  corpoClinico?: UnidadeMedicoEspecialidadeModel;
  beneficiario?: PacienteModel;
  beneficios: ProcedimentoModel[] = [];
  plano?: PlanoModel;
  atendimento?: AtendimentoModel;
  cid10?: Cid10Model;
  finalizado_manual: boolean = false;
  status_Atendimento?: number;
  observacao_Exames?: string;

  // Campo temporário
  public emAtendimento: boolean = false;


  public get status(): string {
    if (this.status_Atendimento === 7) {
      return 'FINALIZADO';
    }
    if (this.status_Atendimento === 2) {
      return 'CONFIRMADO';
    }
    if (this.status_Atendimento === 5) {
      return 'EM ATENDIMENTO';
    }
    if (this.status_Atendimento === 6) {
      return 'ATENDIDO';
    }
    if (this.status_Atendimento === 4) {
      return 'AGUARDANDO';
    }
    if (this.status_Atendimento === 3) {
      return 'CANCELADO';
    }
    return 'AGENDADO';
  }

  public get isTravada(): boolean {
    return this.status !== 'EM ATENDIMENTO';
  }

  public get podeAtender(): boolean {
    return this.status === 'AGUARDANDO' || this.status === 'EM ATENDIMENTO';
  }
  // AGENDADO = 1
  // CONFIRMADO = 2
  // CANCELADO = 3
  // AGUARDANDO = 4
  // EM ATENDIMENTO = 5
  // REALIZADO = 6
  // FINALIZADO = 7
}
